import React from 'react';
import { IconButton } from '@material-tailwind/react';
import { PiXCircle } from 'react-icons/pi';

interface InlineCancelButtonProps {
  onClick: () => void;
  className?: string;
  iconClassName?: string;
}

const InlineCancelButton: React.FC<InlineCancelButtonProps> = ({
  onClick,
  className = '',
  iconClassName = '',
}) => {
  return (
    <IconButton
      onClick={onClick}
      variant="text"
      className={`w-7 h-7 ${className}`}
    >
      <PiXCircle className={`h-5 w-5 text-red-800 ${iconClassName}`} />
    </IconButton>
  );
};

export default InlineCancelButton;
